import React from 'react';

type BlogSidebarSectionProps = {
  title: string;
  withIndicator?: boolean;
  children: React.ReactNode;
  className?: string;
};

const BlogSidebarSection: React.FC<BlogSidebarSectionProps> = ({
  title,
  withIndicator = false,
  children,
  className = '',
}) => (
  <section className={className}>
    <div className="flex items-center gap-2">
      {withIndicator && <span className="h-4 w-px bg-gray-200" />}
      <h4 className="text-gray-900 font-title text-[12px] font-medium uppercase tracking-wider">{title}</h4>
    </div>
    <div className="mt-3">{children}</div>
  </section>
);

export default BlogSidebarSection;
